import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Employee } from '../models/database/employee';
import { StorageService } from '../services/storage/storage.service';
import { RouterClass } from '../services/utils/router/router-class.routes';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private storage: StorageService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let employee: Employee = this.storage.loggedEmployee
    if (!employee || !employee.token) {
      this.router.navigate(RouterClass.routerLinks.auth.LOGIN)
      return false
    }
    return true
  }
}